module.exports = __webpack_public_path__ + "img/NEW_Home Image_text-01-01.f8639fe8.jpg";